const Scopes = {
  MARKETABLE_CONTACTS_ACCESS: 'marketable-contacts-access',
  WORKFLOWS_ENTERPRISE_LIMITS: 'workflows-enterprise-limits',
  WORKFLOWS_VIEW_ALL: 'workflows-view-all',
  WEBHOOK_ACCESS: 'workflows-webhook-access',
  CUSTOM_CODE_ACCESS: 'workflows-custom-code-access',
  FORMAT_DATA_ACCESS: 'workflows-format-data-access',
  SCHEDULED_ENROLLMENT_ACCESS: 'automation-scheduled-enrollment-access',
  SUPER_ADMIN: 'super-admin',
  WORKFLOWS_DELETE_TEAM_OWNED: 'workflows-delete-team-owned',
  WORKFLOWS_EDIT_TEAM_OWNED: 'workflows-edit-team-owned',
  BUSINESS_UNITS_ACCESS: 'business-units-access'
};
export default Scopes;